/**
 * Converts strings and numbers (which may be passed as options as well), to
 * `Option` objects, so we can internally always work with a uniform array of
 * `Option` objects
 *
 * For robustness and flexibilty, a single string or number may also be passed
 * as the options. In this case, the argument will be 'wrapped' in an array,
 * converted as normal, and returned. (I.e., an argument like 'aString' will be
 * treated as ['aString'])
 *
 * @param {Array<object|string|number>|string|number} options
 * @returns {Option[]}
 */
export default function convertOptions(options) {
  return ([].concat(options)).map((option) => {
    if (typeof option === 'string' || typeof option === 'number') {
      return { name: option, value: option };
    }
    return option;
  });
}
